<template>
  <v-app-bar
    app
    class="tradana-shadow"
    color="white"
    light
    fixed
    :style="{ padding: !($vuetify.breakpoint.xs || $vuetify.breakpoint.sm ) ? '0 90px' : '' }"
    :height="$vuetify.breakpoint.mdAndDown ? '60px' : '100px'"
  >
    <!-- Logo -->
    <img src="../../assets/Logo_mit_Subline.png" alt="unvergessen logo" class="desktop-logo hidden-md-and-down" @click="mobileRoute({ name: 'Home' })">
    <img src="../../assets/Logo_mit_Subline.png" alt="unvergessen logo" class="mobile-logo hidden-lg-and-up" @click="mobileRoute({ name: 'Home' })">
    <v-spacer class="hidden-sm-and-down"></v-spacer>
    <div class="hidden-sm-and-down">
      <p style="font-size: 10px; text-align: right">
        Ein Service der Gesellschaft für Erinnerungskultur
      </p>
      <span class="mr-8">hallo@tradana.org</span>
      |
      <span class="ml-8">0681 965 938 84</span>
      <!-- |
      <span style="width: 100%; cursor: pointer" class="pl-8">Anmelden</span> -->
    </div>

    <div style="font-size: 10px; width: 100%; text-align: right; " v-if="$vuetify.breakpoint.sm">
      <p style="font-size: 6px">
        Ein Service der Gesellschaft für Erinnerungskultur
      </p>
      <span class="mr-2">hallo@tradana.org</span>
      |
      <span class="ml-2">0681 965 938 84</span>
      <!-- |
      <span style="width: 100%; cursor: pointer" class="pl-8">Anmelden</span> -->
    </div>

    <div style="font-size: 10px; width: 100%; text-align: right; " v-if="$vuetify.breakpoint.xs">
      <v-icon color="text" class="mr-4" size="30" @click="mailTo()">
        mdi-email
      </v-icon>
      <v-icon color="text" size="30" @click="phone()">
        mdi-phone
      </v-icon>
      <!-- |
      <span style="width: 100%; cursor: pointer" class="pl-8">Anmelden</span> -->
    </div>
  </v-app-bar>
</template>

<script>
export default {
  methods: {
    mobileRoute (to) {
      this.$router.push(to)
    },
    mailTo () {
      window.open('mailto://hallo@tradana.org')
    },
    phone () {
      window.open("tel:+49 681 965 938 84")
    }
  }
}
</script>

<style scoped>
  .desktop-logo {
    height: 100%;
    cursor: pointer;
  }

  .mobile-logo {
    height: 75%;
    cursor: pointer;
  }

  .unvergessen-search-field{
    margin-right: 15px;
  }
</style>
